import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'hvfwebsite';
  public loading :boolean=false;
  
  changeRoute(){ 
    window.scroll(0,0);
    this.loading = true;   
  }
}
